import { Gender } from "constants/enums";
import moment from "moment";

import { CreateNotificationBody } from "../apis";
import { NotificationFormValues } from "../components";

export const convertNotificationFormDataToCreateRequestBody = (
  formData: NotificationFormValues
): CreateNotificationBody => {
  const postingDate =
    formData.postingDate && formData.postingTime
      ? moment(formData.postingDate)
          .set({
            hour: parseInt(formData.postingTime.split(":")[0]),
            minute: parseInt(formData.postingTime.split(":")[1]),
            second: parseInt(formData.postingTime.split(":")[2])
          })
          .toISOString()
      : "";

  return {
    imageId: formData.image?.id,
    title: formData.title,
    description: formData.description,
    postingDate,
    repetition: formData.repetition.neverRepeat
      ? undefined
      : {
          every: +formData.repetition.every,
          type: formData.repetition.type
        },
    redirection:
      formData.productVariants.length > 0
        ? {
            productVariantIds: formData.productVariants.map(
              (variant) => variant.id
            ),
            productSetId: formData.productSet?.id
          }
        : undefined,
    targetGender:
      formData.targetGender === Gender.All ? undefined : formData.targetGender,
    ageFrom: formData.notRelevantAge ? undefined : +formData.age[0],
    ageTo: formData.notRelevantAge ? undefined : +formData.age[1],
    earningsFrom: formData.notRelevantEarnings
      ? undefined
      : +formData.earnings[0],
    earningsTo: formData.notRelevantEarnings
      ? undefined
      : +formData.earnings[1],
    salesFrom: formData.notRelevantSales
      ? undefined
      : formData.salesType === "moreThan"
        ? +formData.salesValue
        : undefined,
    salesTo: formData.notRelevantSales
      ? undefined
      : formData.salesType === "lessThan"
        ? +formData.salesValue
        : undefined,
    numberOfSharesFrom: formData.notRelevantShares
      ? undefined
      : formData.sharesType === "moreThan"
        ? +formData.sharesValue
        : undefined,
    numberOfSharesTo: formData.notRelevantShares
      ? undefined
      : formData.sharesType === "lessThan"
        ? +formData.sharesValue
        : undefined
  };
};
